module.exports = __webpack_public_path__ + "static/media/Tall-min.45bb4b87.PNG";